<template>
	<div class="clx-video">
		<titles :names="'cartoon'"></titles>
		<!-- 主体 -->
		<div class="clx-home-main">
			<div class="clx-home-main-background"></div>
			<!-- 详情 -->
			<div class="clx-home-main-content">
				<div class="clx-home-main-topvideobox">
					<span>动漫解读“1+20”政策①｜关于扎实稳定全省经济运行的一揽子政策措施</span>
					<video src="https://ms4d.hebei.com.cn/video/20220815/de070b36bb3a40d187c01d4a0a9357e2/5555555502ss5128555673658260sp5n_8cda4c927011474eb74e0e49ec32836a.mp4"
						   ref="videoplayer1" :controls="true" @loadeddata="createPreImg($event)" crossorigin="anonymous"
						   :autoplay="true"></video>
<!--					<video src="https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-1.mp4"-->
<!--						ref="videoplayer1" :controls="true" @loadeddata="createPreImg($event)" crossorigin="anonymous"-->
<!--						:autoplay="true"></video>-->
				</div>
				<div @click="showModel(index)" class="clx-home-main-contentbox" v-for="(item,index) in listtudata"
					:key="index">
					<span>{{item.tit}}</span>
					<img :src="item.imgs">
				</div>
			</div>
		</div>
		<div class="video-box" v-if="videoModelShow">
			<video class="video-item" :src="videoplayer" controls ref="videoPlayer"
				@loadeddata="createPreImg($event)" crossorigin="anonymous" :autoplay="true"></video>
			<div class="video-closebox" @click="closeModel">
				<img src="../../assets/clx-images/video/close.png" class="close-video-model">
			</div>
			<div class="video-zhezhao"></div>
		</div>
	</div>
</template>

<script>
	import titles from '../../components/pagetitle/title'
	export default {
		name: "lawyer-c",
		components: {
			titles
		},
		data() {
			return {
				keyword: '', //要搜索关键字
				videoModelShow: false, //视频弹窗隐藏
				videoplayer: '',
				listtudata: [{
						tit: '动漫解读“1+20”政策②｜关于稳住经济的三十条财政政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (1).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策③｜关于稳定经济十条货币金融政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (2).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策④｜关于稳投资的六条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (3).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑤｜关于促消费十四条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (4).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑥｜关于稳住外贸外资基本盘的十六条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (5).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑦｜关于保粮食能源安全的十五条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (6).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑧｜关于保产业链供应链稳定的九条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (7).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑨｜关于保基本民生的十条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (8).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑩｜关于稳住全省工业经济大盘的五条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (9).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑪｜关于扎实推进农业经济发展的十四条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (10).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑫｜关于支持房地产业良性循环和健康发展的五条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (11).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑬｜关于促进交通运输发展的六条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (13).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑭｜关于促进文化产业和旅游业恢复发展的八条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (14).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑮｜关于支持企业高质量发展十条用地政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (15).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑯｜关于稳住经济的五条环保政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (16).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑰|关于科技支持全省经济平稳发展的十二条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (17).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑱|关于扶持企业上市的十一条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (18).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑲|关于进一步促进高校毕业生等青年就业创业十九条政策措施',
						imgs: require('../../assets/jjydt/dmjd/d- (19).png'),
						url: ''
					},
					{
						tit: '动漫解读“1+20”政策⑳｜关于促进法治化营商环境建设的五条政策措施施',
						imgs: require('../../assets/jjydt/dmjd/d- (20).png'),
						url: ''
					},
				]
			}
		},

		methods: {
			onPlayerPause(player) {
				console.log(player)
			},
			// 显示视频弹窗
			showModel(n) {
				this.$refs.videoplayer1.pause()
				// console.log("视频", n)
				switch (n) {
					case 0:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-2.mp4"
						break;
					case 1:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-3.mp4"
						break;
					case 2:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-4.mp4"
						break;
					case 3:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-5.mp4"
						break;
					case 4:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-6.mp4"
						break;
					case 5:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-7.mp4"
						break;
					case 6:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-8.mp4"
						break;
					case 7:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-9.mp4"
						break;
					case 8:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-10.mp4"
						break;
					case 9:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-11.mp4"
						break;
					case 10:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-12.mp4"
						break;
					case 11:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-13.mp4"
						break;
					case 12:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-14.mp4"
						break;
					case 13:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-15.mp4"
						break;
					case 14:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-16.mp4"
						break;
					case 15:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-17.mp4"
						break;
					case 16:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-18.mp4"
						break;
					case 17:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-19.mp4"
						break;
					case 18:
						this.videoplayer = "https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/d-20.mp4"
						break;
					default:
						alert('程序出错！')
						return
				}

				setTimeout(() => {
					this.videoModelShow = true
				})
			},
			// 关闭视频弹窗
			closeModel() {
				this.$refs.videoPlayer.pause()
				this.videoModelShow = false
			},
			createPreImg(event) { // event js原生事件
				const videoEle = event.target; // 当前video dom节点
				videoEle.currentTime = 0; // 设置视频开始播放时间（因为有些手机第一帧显示黑屏，所以这里选取视频的第一秒作为封面）
				videoEle.addEventListener('canplay', function() { // 监听video的canplay事件
					// 创建canvas元素 并设置canvas大小等于video节点的大小
					const canvas = document.createElement('canvas');
					videoEle.oncanplay = () => {
						// const scale = 0.8; // 压缩系数
						canvas.width = videoEle.videoWidth;
						canvas.height = videoEle.videoHeight;
						// canvas画图
						canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);
						// 把canvas转成base64编码格式
						const imgSrc = canvas.toDataURL('image/png');
						videoEle.poster = imgSrc
					};
				});
			},
			// 查询
			iSearch() {
				if (!this.keyword) {
					this.$clxTools.iMessage(this, 'e', '请输入内容后查询', 4)
					return
				}
				this.$router.push({
					name: 'result',
					params: {
						keyword: this.keyword
					}
				})
			},

		},
		created() {
			let keyword = this.$route.params.keyword
		},
		mounted() {
			if(window.screen.width>750){
				console.log("",window.screen.width)
				const html = document.querySelector('html');
				const width =window.screen.width
				html.style.fontSize = width/13 +'px'
			}
		},
	};
</script>

<style lang="less">
	.clx-video {
		width: 7.5rem;
		padding: 0 0.24rem;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
		background: url(../../assets/clx-images/big-bg2.jpg) no-repeat center 0px;
		background-size: cover;

		// 主体
		.clx-home-main {
			// height: ~"calc(100vh -6rem)";
			// min-height: 5rem;
			height: 58%;
			position: relative;
			border-radius: 0.1rem;
			width: 100%;

			.clx-home-main-background {
				top: 0;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: #fff;
				border-radius: 0.2rem;
				border: 0.01rem solid #FFC35D;
				opacity: 0.4;
				z-index: 1;
			}

			// 内容
			.clx-home-main-content {
				// padding: 0.32rem 0.3rem;
				height: 100%;
				z-index: 2;
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;

				.clx-home-main-topvideobox {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					align-items: center;
					padding: 0.3rem 0;
					margin: 0 0.3rem;
					border-bottom: 0.02rem solid #D7D7D7;

					span {
						font-size: 0.34rem;
						color: #000;
						font-weight: 400;
					}

					video {
						max-width: 100%;
						border-radius: 0.2rem;
						overflow: hidden;
						margin-top: 0.21rem;
					}
				}

				.clx-home-main-contentbox {
					padding: 0.3rem 0;
					margin: 0 0.3rem;
					display: flex;
					flex-direction: row;
					justify-content: space-around;
					align-items: center;
					border-bottom: 0.02rem solid #D7D7D7;

					span {
						font-size: 0.34rem;
						color: #000;
						font-weight: 400;
						display: block;
						width: 4.14rem;
						padding-right: 0.22rem;
					}

					img {
						max-width: 2.26rem;
					}
				}


				// 滚动条
				&::-webkit-scrollbar-track-piece {
					background-color: rgba(0, 0, 0, 0);
					border-left: 1px solid rgba(0, 0, 0, 0);
				}

				&::-webkit-scrollbar {
					width: 2px;
					height: 13px;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: rgba(0, 0, 0, 0.2);
					background-clip: padding-box;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
					min-height: 28px;
				}

				&::-webkit-scrollbar-thumb:hover {
					background-color: rgba(0, 0, 0, 0.2);
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}
			}
		}

		.video-box {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 10;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;


			.video-item {
				width: 90%;
				// padding: 5%;
				border-radius: 10px;
				overflow: hidden;
				margin-top: 200px;
				z-index: 12;
			}

			.video-closebox {
				width: 50px;
				height: 50px;
				margin-top: 30px;
				z-index: 12;
			}

			.video-closebox img {
				max-width: 100%;
				max-height: 100%;
			}

			.video-zhezhao {
				width: 100%;
				height: 100%;
				z-index: 11;
				position: fixed;
				background-color: #000;
				opacity: 0.7;
			}
		}
	}
</style>
